<template>
  <section class="complex-list">
    <slot name="header" />
    <ul class="list">
      <slot />
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.complex-list {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  gap: 2px;
  height: 100%;

  :deep(.list-banner),
  :deep(.list-group) {
    &:not(:first-of-type) {
      margin-top: 16px;
    }
  }

  .list {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    overflow-y: auto;
  }
}
</style>
